import { axios } from './config';

export function getPublicBeneByGiftCode() {
  return axios.get('/gift/beneficiary');
};

export function getValidateGiftCode(giftCode) {
  return axios.get(`/gift/validate/${giftCode}`);
};
